import React from 'react';
import './Contact.css';

import { Button } from "../../components/ui/Button/Button";

const Contact = () => {
  return (
	<section id="contact">
		<h2>Contactez-moi</h2>
		<p>
			Prêt à collaborer ? Discutons de vos projets !
		</p>
		{/*<form>
			<input
			type="text"
			placeholder="Nom"
			/>
			<input
			type="email"
			placeholder="Email"
			/>
			<textarea
			placeholder="Message"
			rows="4"
			></textarea>
			<Button>
				Envoyer
			</Button>
		</form>*/}
		<div class="contact-info">
			{/*<p>Ou contactez-moi directement :</p>*/}
			<a href="mailto:jbrung@eoarts.fr">jbrung@eoarts.fr</a>
			<div class="social-links">
				<a href="https://www.facebook.com/people/Eo-Arts/61578049119562/" target="_blank" aria-label="Facebook">
					<i class="fab fa-facebook"></i>
				</a>
				{<a href="https://www.instagram.com/eoartsfr/" target="_blank" aria-label="Instagram">
					<i class="fab fa-instagram"></i>
				</a>}
				<a href="https://www.linkedin.com/company/107887187" target="_blank" aria-label="LinkedIn">
					<i class="fab fa-linkedin"></i>
				</a>
			</div>
		</div>
	</section>
  );
};

export default Contact;